import { useTranslation } from "react-i18next";

import icons from "../../../../Data/icons";
import classes from "./navtabs.module.css";


const NavTabs = ({handleActiveTab,activeTab}) => {
  const { t } = useTranslation();

  const Password = icons.password
  const Employ = icons.employ

  return (
    <div className={classes.NavCol}>
      <div className={classes.NavCard}>
        <ul className={classes.TabsList}>
          <li onClick={()=>handleActiveTab("profile" , "/user/profile")} className={` ${activeTab==="profile" && classes.activeTab }`}>
            <h5>
              <span>
                <Employ />
              </span>
              {t("Profile")}
            </h5>    
          </li>
          <li onClick={()=>handleActiveTab("changepassword", "/user/changepassword")} className={` ${activeTab==="changepassword" && classes.activeTab }`}>
            <h5>
              <span>
                <Password />
              </span>
              {t("Change Password")}
            </h5>
          </li>
       
          
        </ul>
      </div>
    </div>
  );
};

export default NavTabs;
